import Vue from "vue";
import UrlParser from "@/module/Utils/UrlParser";

interface ComponentData {
  value: string | null;
}

export default Vue.extend({
  props: {
    queryParam: {
      type: String,
      default: "",
    },
  },

  data(): ComponentData {
    return {
      value: null,
    };
  },

  computed: {
    finalQueryParam(): string {
      return this.queryParam;
    },
  },

  methods: {
    getValidationState(failed: boolean, errors: Array<string>): boolean | null {
      return failed ? (errors.length === 0 ? null : false) : null;
    },

    getFirstError(errors: Array<string>): string | null {
      return errors.length > 0 ? errors[0] : null;
    },

    loadDataFromQuery(): void {
      if (!this.finalQueryParam) {
        return;
      }

      const urlParser = UrlParser.getInstance();

      const value =
        urlParser.getParamFromFormData("fapi-form-" + this.finalQueryParam) ||
        urlParser.getParam("fapi-form-" + this.finalQueryParam);

      if (value === null || value === "") {
        return;
      }

      this.value = String(value);
    },
  },
});
